export { default as CrossedBellIcon } from './CrossedBellIcon';
